import { DatePicker } from '@hologram-dimension/date-picker';
import { FormField } from '@hologram-dimension/form-field';
import { Select } from '@hologram-dimension/select';
import { ValidationMessage } from '@hologram-dimension/validation-message';
import clsx from 'clsx/lite';
import type { FC } from 'react';
import type { DatePickerProps } from 'types/common';
import styles from './Timeframe.module.css';

type SelectOptions = Array<{ label: string; value: string }>;

type SelectProps = Omit<GetReactParameterBag<typeof Select>, 'id' | 'options' | 'inputProps'>;

interface TimeframeProps {
  id: string;
  options: SelectOptions;
  timeframeProps: SelectProps;
  startFieldProps: DatePickerProps;
  endFieldProps: DatePickerProps;
  invalid?: boolean;
  validationMessage?: string;
  className?: string;
}

// TODO: This should be in Dimension. Consider making this a controlled input so caller doesn't have to deal with setting start/end values on change?

const Timeframe: FC<TimeframeProps> = ({
  id,
  options,
  timeframeProps,
  startFieldProps,
  endFieldProps,
  invalid,
  validationMessage,
  className,
}) => (
  <div className={clsx(styles.wrapper, className)} id={id}>
    <Select
      id={`${id}-range`}
      options={options}
      inputProps={{ 'data-1p-ignore': true, 'data-lpignore': true } as any}
      {...timeframeProps}
    />
    <FormField
      label="Start date"
      className={styles.formField}
      id={`${id}-start`}
      layoutDirection="row"
      centerLabel
    >
      {({ ariaDescribedbyIds, ariaLabel, primaryControlId }) => (
        <DatePicker
          id={primaryControlId}
          aria-describedby={ariaDescribedbyIds}
          aria-label={ariaLabel}
          {...startFieldProps}
        />
      )}
    </FormField>
    <FormField
      label="End date"
      className={styles.formField}
      id={`${id}-end`}
      layoutDirection="row"
      centerLabel
    >
      {({ ariaDescribedbyIds, ariaLabel, primaryControlId }) => (
        <DatePicker
          id={primaryControlId}
          aria-describedby={ariaDescribedbyIds}
          aria-label={ariaLabel}
          {...endFieldProps}
        />
      )}
    </FormField>
    {validationMessage && (
      <ValidationMessage id="lastActive-validation" invalid={invalid} className={styles.validation}>
        {validationMessage}
      </ValidationMessage>
    )}
  </div>
);

export default Timeframe;
